import { getOfficeByFirm } from "../../../../Services/Office";
import {
  collapseOfficeRowsToAssignments,
  expandDataAdminsToOfficeRows,
  resolveDataAdminOfficeIdForPerson,
} from "../../../../pages/ManageFirm/Professionals/manageDataAdminOfficeRules";
import {
  getDataAdminByFirmId,
  syncDataAdminsForFirm,
} from "../../../../Services/DataAdmin";
import type { DataAdminView } from "../../../../interfaces/models/IDataAdmin";

/**
 * Adds a data-admin assignment for a person based on main-office rules.
 * Uses the same sync endpoint as ManageDataAdmin.
 */
export async function syncDataAdminsForNewPersonAssignments(
  firmId: string,
  personId: string,
  mainOfficeId?: string,
): Promise<DataAdminView[] | null> {
  const normalizedFirmId = String(firmId ?? "").trim();
  const normalizedPersonId = String(personId ?? "").trim();
  if (!normalizedFirmId || !normalizedPersonId) {
    return null;
  }

  const offices = await getOfficeByFirm(normalizedFirmId);
  const officeList = Array.isArray(offices) ? offices : [];
  const dataAdminOfficeId = resolveDataAdminOfficeIdForPerson(
    officeList,
    mainOfficeId,
  );
  if (!dataAdminOfficeId) {
    return null;
  }

  const existing = await getDataAdminByFirmId(normalizedFirmId);
  const existingAssignments = collapseOfficeRowsToAssignments(
    expandDataAdminsToOfficeRows(existing),
  );

  const key = `${normalizedPersonId}:${dataAdminOfficeId}`;
  const alreadyAssigned = existingAssignments.some(
    (assignment) =>
      `${assignment.personId}:${assignment.officeId}` === key,
  );
  if (alreadyAssigned) {
    return null;
  }

  return syncDataAdminsForFirm(normalizedFirmId, [
    ...existingAssignments,
    { personId: normalizedPersonId, officeId: dataAdminOfficeId },
  ]);
}
